import {
  Component,
  OnInit,
  AfterViewInit,
  ChangeDetectorRef,
} from "@angular/core";
import * as Chart from "chart.js";
import { DataService } from "../data.service";
import { EventsService } from "angular4-events";
import { Constants } from "../constants";

declare var $: any;
declare var Nanobar: any;
declare var toastr: any;
declare var moment: any;

@Component({
  selector: "app-dashboard",
  templateUrl: "./dashboard.component.html",
  styleUrls: ["./dashboard.component.css"],
})
export class DashboardComponent implements OnInit {
  priceIconForSingle = Constants.iconForSinglePrice;
  priceIconForDouble = Constants.iconForDoublePrice;
  nao = new Nanobar();
  canvas: any;
  canvasSale: any;
  ctx: any;
  ctxSale: any;
  saleDataGraph: any;
  saleDataGraphLabel = new Array();
  saleDataGraphValue = new Array();
  orderDataGraph: any;
  financialBoardData: any;
  orderDataGraphLabel = new Array();
  orderDataGraphValue = new Array();
  dashboardData: any;
  driverData: any;
  productData: any;
  userData: any;
  outletData: any;
  orderData: any;
  saleData: any;
  topDriver: any;
  topUser: any;
  topProducts: any;
  topBusinesses: any;
  topCategories: any;
  start_date: any;
  saleString: any;
  end_date: any;
  orderMaxValue: any;
  saleMaxValue: any;
  loadingData = true;
  payment_collection: any;
  pendingCount: any;
  dataGraph = [1000, 2500, 1200, 4500, 5000, 6000, 7000, 8000];

  type: number = 3;
  searchBusiness: string = "";
  BusinessFilterString: string = "All-Businesses";
  searchTimeOut: any;
  searchBusinessDetailforOrder: any;
  min_date: any = "";
  max_date: any = "";
  business_list: number[] = [];
  business_category_list: number[] = [];

  categoryList: any[];
  BusinessCategoryString: string = "All-Categories";

  businessNames: any = [];
  categoryNames: any = [];

  constructor(
    private dataService: DataService,
    private ref: ChangeDetectorRef,
    private events: EventsService
  ) {
    if (window.localStorage.getItem("isauthenticated") !== "true") {
      window.location.href = "/";
    }
  }
  // onStatChange () {
  //   this.dataGraph = [];
  //   console.log('test', this.dataGraph);
  //   this.dataGraph = [4000, 1000, 2500, 10000];
  //     this.ref.detectChanges();
  //     this.chartInit();
  //   console.log('test', this.dataGraph);
  // }
  getDashboardData() {
    if (this.type === 1) {
      this.saleString = "Today";
    }
    if (this.type === 2) {
      this.saleString = "Weekly";
    }
    if (this.type === 3) {
      this.saleString = "Monthly";
    }
    this.nao.go(30);
    this.dataService
      .homeData(
        window.localStorage.getItem("token"),
        this.type,
        this.min_date,
        this.max_date,
        this.business_list,
        this.business_category_list
      )
      .subscribe(
        (data) => {
          this.nao.go(100);
          this.dashboardData = data;
          this.payment_collection = this.dashboardData.payment_collection;
          this.outletData = this.dashboardData.outlets;
          this.orderData = this.dashboardData.orders;
          this.saleData = this.dashboardData.sale;
          this.pendingCount =
            this.dashboardData.total_count_of_pending_businesses;
          window.localStorage.setItem(
            "BusinessPendingCount",
            this.pendingCount
          );
          this.events.publish("BusinessPending", this.pendingCount);
          window.localStorage.setItem(
            "pendingRequests",
            this.dashboardData.order_text_count
          );
          window.localStorage.setItem(
            "force_dropoff_pending_count",
            this.dashboardData.force_dropoff_pending_count
          );
          if (this.dashboardData.rest_error_code === 1)
            toastr.error("Some thing went wrong");
          if (this.dashboardData.rest_error_code === 2)
            toastr.error("Please login again");
          if (this.dashboardData.rest_error_code === 4)
            toastr.error("Does not exist");
          this.loadingData = false;
        },
        (error) => {
          this.nao.go(100);
          console.log("error", error);
          toastr.error("Some thing went wrong");
        }
      );
  }
  showRangePicker: boolean = false;

  updateData(type) {
    if (type === "until-today") {
      this.type = 0;
      this.getDashboardData();
      this.getFinanicalBoardData();
      this.orderGraphData();
      this.getSalesData();
    }
    if (type === "today") {
      this.type = 1;
      this.getDashboardData();
      this.getFinanicalBoardData();
      this.orderGraphData();
      this.getSalesData();
    }
    if (type === "weekly") {
      this.type = 2;
      this.getDashboardData();
      this.getFinanicalBoardData();
      this.orderGraphData();
      this.getSalesData();
    }
    if (type === "monthly") {
      this.type = 3;
      this.getDashboardData();
      this.getFinanicalBoardData();
      this.orderGraphData();
      this.getSalesData();
    }
    if (type === "90Days") {
      this.type = 4;
      this.getDashboardData();
      this.getFinanicalBoardData();
      this.orderGraphData();
      this.getSalesData();
    }
    if (type === "custom") {
      this.type = 5;
      this.showRangePicker = true;
    }
    if (this.type != 5) {
      this.showRangePicker = false;
      this.min_date = "";
      this.max_date = "";
    }
  }

  orderGraphData() {
    this.orderDataGraphLabel = [];
    this.orderDataGraphValue = [];
    this.saleDataGraphLabel = [];
    this.saleDataGraphValue = [];
    // this.nao.go(30);
    this.dataService
      .graphData(
        window.localStorage.getItem("token"),
        this.type,
        this.min_date,
        this.max_date,
        this.business_list,
        this.business_category_list
      )
      .subscribe(
        (data) => {
          // this.nao.go(100);
          this.orderDataGraph = data;
          this.orderDataGraph = this.orderDataGraph.list;
          this.orderMaxValue = data;
          this.orderMaxValue = this.orderMaxValue.max_value;
          for (var i = 0; i < this.orderDataGraph.length; i++) {
            this.orderDataGraphLabel.push(
              this.orderDataGraph[i].label.toString()
            );
            this.orderDataGraphValue.push(this.orderDataGraph[i].value);
          }

          this.saleDataGraph = data;
          this.saleDataGraph = this.saleDataGraph.list_new;
          this.saleMaxValue = data;
          this.saleMaxValue = this.saleMaxValue.max_value;
          for (var i = 0; i < this.saleDataGraph.length; i++) {
            this.saleDataGraphLabel.push(
              this.saleDataGraph[i].label.toString()
            );
            this.saleDataGraphValue.push(this.saleDataGraph[i].value);
          }
          console.log(
            "insomniac: => ",
            this.saleDataGraphLabel,
            this.saleDataGraphValue
          );
          this.chartInit();
          this.chartInitSale();
        },
        (error) => {
          // this.nao.go(100);
        }
      );
  }

  restrictUserInput($event) {
    $event.preventDefault();
  }
  chartInit() {
    $("#myChart").remove(); // this is my <canvas> element
    $("#myChart-container").append('<canvas id="myChart"><canvas>');
    this.canvas = document.getElementById("myChart");
    this.ctx = this.canvas.getContext("2d");
    var yAxesticks = [];
    var highestVal;
    let myChart = new Chart(this.ctx, {
      type: "bar",
      data: {
        labels: this.orderDataGraphLabel,
        datasets: [
          {
            label: "",
            lineTension: 0,
            data: this.orderDataGraphValue,
            backgroundColor: ["rgba(255, 255, 255, 0.2)"],

            borderColor: [
              "rgba(255,99,132,1)",
              "rgba(54, 162, 235, 1)",
              "rgba(255, 206, 86, 1)",
              "rgba(75, 192, 192, 1)",
              "rgba(153, 102, 255, 1)",
              "rgba(255, 159, 64, 1)",
            ],
            borderWidth: 1,
          },
          //     {
          //     label: '',
          //     lineTension: 0,
          //     data: [1100, 2000, 1200, 1000, 5000],
          //     backgroundColor: [
          //         'rgba(255, 255, 255, 0.2)',
          //     ],

          //    borderColor: [
          //         'rgba(255,99,132,1)',
          //         'rgba(54, 162, 235, 1)',
          //         'rgba(255, 206, 86, 1)',
          //         'rgba(75, 192, 192, 1)',
          //         'rgba(153, 102, 255, 1)',
          //         'rgba(255, 159, 64, 1)'
          //     ],
          //     borderWidth: 1
          // }
        ],
      },
      options: {
        bezierCurve: false,

        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
                //                             max: 7000,
                //                           callback : function(value, index, values) {
                //                                     yAxesticks = values;
                //                                     return value;
                //                                 },
                stepSize: Math.ceil(this.orderMaxValue) / 3,
                // min: 1000
              },
            },
          ],
        },
        legend: {
          display: false,
        },
        tooltips: {
          enabled: true,
        },
        maintainAspectRatio: false,
      },
    });
    highestVal = yAxesticks[0];
    console.log("highestVal", highestVal);
  }
  chartInitSale() {
    $("#saleChart").remove(); // this is my <canvas> element
    $("#saleChart-container").append('<canvas id="saleChart"><canvas>');
    this.canvasSale = document.getElementById("saleChart");
    this.ctxSale = this.canvasSale.getContext("2d");
    let myChart = new Chart(this.ctxSale, {
      type: "bar",
      data: {
        labels: this.saleDataGraphLabel,
        datasets: [
          {
            label: "",
            lineTension: 0,
            data: this.saleDataGraphValue,
            backgroundColor: ["rgba(255, 255, 255, 0.2)"],

            borderColor: [
              "rgba(255,99,132,1)",
              "rgba(54, 162, 235, 1)",
              "rgba(255, 206, 86, 1)",
              "rgba(75, 192, 192, 1)",
              "rgba(153, 102, 255, 1)",
              "rgba(255, 159, 64, 1)",
            ],
            borderWidth: 1,
          },
        ],
      },
      options: {
        bezierCurve: false,
        scales: {
          yAxes: [
            {
              ticks: {
                //                            beginAtZero: true
                //                             max: 7000,
                // stepSize: Math.ceil(this.saleMaxValue) / 3,
                // min: 1000
              },
            },
          ],
        },
        legend: {
          display: false,
        },
        tooltips: {
          enabled: true,
        },
        maintainAspectRatio: false,
      },
    });
  }
  ngOnInit() {
    this.getDashboardData();
    this.getSalesData();
    this.getFinanicalBoardData();
    this.orderGraphData();
    this.getDispensaryListing();
    this.getbusinessCategoryListing();
    $("#dateStart, #dateEnd").datepicker({
      format: "mm/dd/yyyy", // Notice the Extra space at the beginning
      defaultDate: " -10d",
      endDate: new Date(),
    });
    $(".header").css("display", "inline-block");
    $(".footer").css("display", "inline-block");
    $("#sidebar").css("display", "block");
    $(".clearSideSelecteion").css("color", "#3d3d3d");
    $("#dashboard").css("color", "#d77229");
  }
  ngAfterViewInit() {
    // this.chartInit();
  }

  getSalesData() {
    this.dataService
      .salesData(
        window.localStorage.getItem("token"),
        this.type,
        this.min_date,
        this.max_date,
        this.business_list,
        this.business_category_list
      )
      .subscribe((res: any) => {
        console.log(res);
        this.userData = res.users;
        this.topUser = this.userData.top_user || [];
        this.driverData = res.drivers;
        this.topDriver = this.driverData.top_driver || [];
        this.topProducts = res.products;
        this.topBusinesses = res.businesses;
        this.topCategories = res.categories;
      });
  }

  getFinanicalBoardData() {
    this.dataService
      .financialBoardData(
        window.localStorage.getItem("token"),
        this.type,
        this.min_date,
        this.max_date,
        this.business_list,
        this.business_category_list
      )
      .subscribe((res: any) => {
        this.financialBoardData = res;
        // this.userData = res.users;
        // this.topUser = this.userData.top_user || [];
        // this.driverData = res.drivers;
        // this.topDriver = this.driverData.top_driver || [];
        // this.topProducts = res.products;
        // this.topBusinesses = res.businesses;
        // this.topCategories = res.categories;
      });
  }

  getDispensaryListing() {
    this.dataService
      .getdispensaryListing(localStorage.getItem("token"))
      .subscribe(
        (data) => {
          this.searchBusinessDetailforOrder = data;
          this.BusinessFilterString = "All-Businesses";
        },
        (error) => {
          // this.nao.go(100);
          console.log("error", error);
          toastr.error("Something went wrong");
        }
      );
  }

  //for getting only selected business listing after selecting the category
  getSelectedDispensaryListing(selectedCategories : any) {
    this.dataService
      .getSelectedDispensaryListing(localStorage.getItem("token"), selectedCategories)
      .subscribe(
        (data) => {
          this.searchBusinessDetailforOrder = data;
          this.BusinessFilterString = "All-Businesses";
        },
        (error) => {
          // this.nao.go(100);
          toastr.error("Something went wrong");
        }
      );
  }


  getbusinessCategoryListing() {
    this.nao.go(30);
    this.dataService
      .getBusinessCategory(window.localStorage.getItem("token"))
      .subscribe(
        (data: any) => {
          this.nao.go(100);
          this.categoryList = data;
          this.categoryList = this.categoryList.filter(
            (cat) => cat.is_featured == true
          );
        },
        (error) => {
          this.nao.go(100);
          console.log("error", error);
        }
      );
  }

  searchSpecificBusiness() {
    clearTimeout(this.searchTimeOut);
    this.searchTimeOut = setTimeout(() => {
      this.dataService
        .getdispensaryListingById(
          localStorage.getItem("token"),
          "",
          this.searchBusiness
        )
        .subscribe(
          (data) => {
            this.searchBusinessDetailforOrder = data;
          },
          (error) => {
            console.log("error", error);
            toastr.error("Some thing went wrong");
          }
        );
    });
  }

  customDateFilter(event) {
    console.log(event);
    this.min_date = moment(event[0]).format("YYYY-MM-DD");
    this.max_date = moment(event[1]).format("YYYY-MM-DD");
    this.getDashboardData();
    this.getFinanicalBoardData();
    this.getSalesData();
    this.orderGraphData();
  }

  ApplyBusinessFilter(dispensary_id, dispensary_name, event) {
    if (dispensary_id == -1) {
      this.business_list = [];
    } else {
      let checked = event.target.checked;
      if (checked) {
        this.business_list.push(dispensary_id);
        this.businessNames.push(dispensary_name);
      } else {
        this.business_list.splice(
          this.business_list.lastIndexOf(dispensary_id),
          1
        );
        this.businessNames.splice(
          this.businessNames.lastIndexOf(dispensary_name),
          1
        );

        dispensary_name = this.businessNames[this.businessNames.length - 1];
      }
    }
    if (this.business_list.length) {
      if (this.business_list.length == 1) {
        this.BusinessFilterString = dispensary_name;
      } else if (this.business_list.length == 2) {
        this.BusinessFilterString =
          dispensary_name + " & " + (this.business_list.length - 1) + " other";
      } else if (this.business_list.length > 2) {
        this.BusinessFilterString =
          dispensary_name + " & " + (this.business_list.length - 1) + " others";
      }
    } else {
      this.BusinessFilterString = "All-Businesses";
    }
    this.getDashboardData();
    this.getFinanicalBoardData();
    this.getSalesData();
    this.orderGraphData();
  }

  ApplyCategoryFilter(id, name, event) {
    if (id == -1) {
      this.business_category_list = [];
    } else {

      let checked = event.target.checked;
      if (checked) {
        this.business_category_list.push(id);
        this.categoryNames.push(name);
      } else {
        this.business_category_list.splice(
          this.business_category_list.lastIndexOf(id),
          1
        );
        this.categoryNames.splice(this.categoryNames.lastIndexOf(name), 1);
        name = this.categoryNames[this.categoryNames.length - 1];
      }
    }

    if (this.business_category_list.length) {
      if (this.business_category_list.length == 1) {
        this.BusinessCategoryString = name;
      } else if (this.business_category_list.length == 2) {
        this.BusinessCategoryString =
          name + " & " + (this.business_category_list.length - 1) + " other";
      } else if (this.business_category_list.length > 2) {
        this.BusinessCategoryString =
          name + " & " + (this.business_category_list.length - 1) + " others";
      }
    } else {
      this.BusinessCategoryString = "All-Categories";
    }    
    this.getSelectedDispensaryListing(this.business_category_list);
    this.getDashboardData();
    this.getFinanicalBoardData();
    this.getSalesData();
    this.orderGraphData();
  }
}



// WEBPACK FOOTER //
// ./src/app/dashboard/dashboard.component.ts